import React, { useMemo } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { useUrlParams } from "hooks";

import styles from "./searchForm.module.scss";
type SearchFormData = {
	query: string;
};

const SearchForm = () => {
	const urlParams = useUrlParams(true);
	const defaultQuery = useMemo(() => {
		return urlParams.get("q") || "";
	}, [urlParams]);

	const { register, handleSubmit } = useForm<SearchFormData>();

	const history = useHistory();

	const onSearchSubmit = ({ query }) => {
		if (query.trim()) {
			history.push(`/search?q=${encodeURIComponent(query)}`);
		}
	};

	return (
		<form onSubmit={handleSubmit(onSearchSubmit)}>
			<InputGroup>
				<Form.Control
					{...register("query")}
					className={styles.query}
					defaultValue={defaultQuery}
					placeholder="Search"
				/>
				<InputGroup.Append>
					<button type="submit" className={styles.submitBtn}>
						Ok
					</button>
				</InputGroup.Append>
			</InputGroup>
		</form>
	);
};

export default SearchForm;
